__turbopack_context__.v({
  "contentWrapper": "GamepadDevCard-module__udwowG__contentWrapper",
  "gamepadDevCard": "GamepadDevCard-module__udwowG__gamepadDevCard",
  "icon": "GamepadDevCard-module__udwowG__icon",
  "infoWrapper": "GamepadDevCard-module__udwowG__infoWrapper",
});
